import { isAndroid, isIOS, remove } from '@star/utils';
import { start, useMsgStore } from '@star/stores';

export const removeLastNotice = () => remove('lastNotic');

// 获取全部公告
export const getAllNotice = (
  payload: any = {
    num_per_page: 5,
    chan_con: 8,
    apply: 8,
  },
  nosave = true
) => {
  const msgStore = useMsgStore();
  return msgStore.reqNewList(payload, nosave);
};

export const getChanCon = () => {
  let chan_con = 8;
  if (isIOS() && start.appVersion > 0) {
    chan_con = 2;
  }
  if (isAndroid() && start.appVersion > 0) {
    chan_con = 1;
  }
  return chan_con;
};
